import { useEffect, useState } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import MenuIcon from '@mui/icons-material/Menu';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';
import SmartToyOutlinedIcon from '@mui/icons-material/SmartToyOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import ChatOutlinedIcon from '@mui/icons-material/ChatOutlined';
import PersonSearchOutlinedIcon from '@mui/icons-material/PersonSearchOutlined';
import InstagramIcon from '@mui/icons-material/Instagram';
import LogoutIcon from '@mui/icons-material/Logout';
import { logoutUser } from '../../../services/session';
import './manager.css';

const NAV_ITEMS = [
  { to: '/manager/users',       icon: <PeopleAltOutlinedIcon sx={{ fontSize: 20 }} />,   label: 'Usuários' },
  { to: '/manager/restaurantes',icon: <StorefrontOutlinedIcon sx={{ fontSize: 20 }} />,  label: 'Restaurantes' },
  { to: '/manager/clientes',    icon: <GroupOutlinedIcon sx={{ fontSize: 20 }} />,        label: 'Clientes' },
  { to: '/manager/atendabot-prospects', icon: <PersonSearchOutlinedIcon sx={{ fontSize: 20 }} />, label: 'Prospects Atendabot' },
  { to: '/manager/logs',        icon: <ListAltOutlinedIcon sx={{ fontSize: 20 }} />,      label: 'Logs' },
  { to: '/manager/bots',        icon: <SmartToyOutlinedIcon sx={{ fontSize: 20 }} />,     label: 'Bots' },
  { to: '/manager/atendabot-template', icon: <DescriptionOutlinedIcon sx={{ fontSize: 20 }} />, label: 'Template Atendabot' },
  { to: '/manager/promotions',  icon: <LocalOfferOutlinedIcon sx={{ fontSize: 20 }} />,   label: 'Promoções' },
  { to: '/manager/zapi',        icon: <WhatsAppIcon sx={{ fontSize: 20 }} />,             label: 'WhatsApp' },
  { to: '/manager/instagram',   icon: <InstagramIcon sx={{ fontSize: 20 }} />,            label: 'Instagram' },
  { to: '/manager/whatsapp-preview-prompts', icon: <ChatOutlinedIcon sx={{ fontSize: 20 }} />, label: 'Prompts WhatsApp' },
];

const ManagerLayout = () => {
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const isMobile = () => window.innerWidth <= 900;

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 900) setMobileOpen(false);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleLogout = async () => {
    await logoutUser();
    navigate('/');
  };

  const toggleSidebar = () => {
    if (isMobile()) setMobileOpen((p) => !p);
    else setCollapsed((p) => !p);
  };

  const closeMobile = () => setMobileOpen(false);

  const isCollapsed = collapsed && !mobileOpen;

  return (
    <div className="manager-layout">
      <div className={`manager-overlay${mobileOpen ? ' open' : ''}`} onClick={closeMobile} />

      <aside className={`manager-sidebar${isCollapsed ? ' collapsed' : ''}${mobileOpen ? ' open' : ''}`}>

        {/* ── Nav ── */}
        <nav className="manager-nav">
          {NAV_ITEMS.map(({ to, icon, label }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) => isActive ? 'active' : ''}
              onClick={closeMobile}
              title={isCollapsed ? label : undefined}
            >
              {icon}
              <span>{label}</span>
            </NavLink>
          ))}
        </nav>

        {/* ── Footer: logout ── */}
        <div className="manager-logout-area">
          <button
            className="manager-logout-btn"
            onClick={handleLogout}
            title={isCollapsed ? 'Sair' : undefined}
          >
            <LogoutIcon sx={{ fontSize: 18, flexShrink: 0 }} />
            <span>Sair</span>
          </button>
        </div>
      </aside>

      <main className={`manager-content${isCollapsed ? ' is-collapsed' : ''}`}>
        <header className="manager-header">
          <button
            className="manager-header-toggle"
            onClick={toggleSidebar}
            aria-label={mobileOpen ? 'Fechar menu' : isCollapsed ? 'Expandir menu' : 'Recolher menu'}
          >
            <MenuIcon sx={{ fontSize: 20 }} />
          </button>
          <div className="manager-header-divider" />
          <button
            className="manager-header-back"
            onClick={() => navigate('/products')}
          >
            <ArrowBackIcon sx={{ fontSize: 16, flexShrink: 0 }} />
            <span>Voltar para produtos</span>
          </button>
        </header>
        <Outlet />
      </main>
    </div>
  );
};

export default ManagerLayout;
